import "./Dashboard_control.css";
import React, { useEffect, useState, useRef, useMemo } from "react";
import ReactJson from "@microlink/react-json-view";
import { Scrapping_status } from "./Scrapping_status";
import { Process_modal } from "./Prococess_modal";
import { Setting_all } from "./Setting_all";
import { System_logs } from "./System_logs";

export function Dashboard_control() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
const [error, setError] = useState("");


  const [threadz, setThread] = useState({});
  const StatusComponent = useMemo(
    () => <Scrapping_status job_status={threadz} />,
    [threadz]
  );
  const [showRun, setShowRun] = useState(null);
  const [showDropdown, setShowDropdown] = useState(null);
  // Instead of null:
  const [status, setStatus] = useState({});
  const [stage, setStage] = useState({});

  console.log("thread_status", threadz);

  const [polling, setPolling] = useState(false);

  const handleClick = (scriptName) => {
    setShowRun((prev) => (prev === scriptName ? null : scriptName));
  };

  const handleDropdownClick = (scriptName) => {
    setShowDropdown((prev) => (prev === scriptName ? null : scriptName));
  };

  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";


   // ---------------------------------------------------------
    // LOAD TASKS
    // ---------------------------------------------------------

    async function loadTasks() {
      setLoading(true);
      setError("");

      try {
          const response = await fetch(
              `${API_URL}/task/main_tbl/retrieval`
          );

          if (!response.ok) {
              throw new Error(
                  `Could not load tasks (${response.status}).`
              );
          }

          const data = await response.json();          
          const taskList = Array.isArray(data)
              ? data
              : data.tasks;

          if (!Array.isArray(taskList)) {
              throw new Error(
                  "The API returned an unexpected task list."
              );
          }

          setTasks(taskList);
      } catch (err) {
          setError(
              err.message || "Could not connect to FastAPI."
          );
      } finally {
          setLoading(false);
      }
  }

  useEffect(() => {
      loadTasks();
  }, []);
 
  



  // 2️⃣ Poll status until success or error
  const pollStatus = (scriptName) => {
    const interval = setInterval(async () => {
      try {   
        const res = await fetch(
            `${API_URL}/status/${encodeURIComponent(scriptName)}/`
        );
       
        if (!res.ok) {
          throw new Error(
              `Status request failed (${res.status}).`
          );
        }
        const data = await res.json();

        console.log("returns_status", data);

        const text = `${data?.status}${data.detail ? ` (${data.detail})` : ""}`;

        setStatus((prev) => ({ ...prev, [scriptName]: text }));
        if (data.stage) {
          setStage((prev) => ({
            ...prev,
            [scriptName]: data.stage,
          }));
        }
        if (data?.threads) {
          const newMap = {};
          Object.values(data.threads).forEach((worker) => {
            const worker_name = worker.worker_name;
            newMap[worker_name] = {};

            worker.jobs?.forEach((job) => {
              newMap[worker_name][job.team_code] = {
                status: job.status,
                duration: job.duration,
                worker_name: worker_name,
                error: job.error,
              };
            });
          });
          setThread((prev) => ({
            ...prev,
            ...newMap,
          }));
        }

        if (data.error) {
          setLogs((prev) => [
            ...prev,
            {
              message: `Script ${scriptName}: ${data.error}`,
              level: "error",
            },
          ]);
        }

       
      } catch (err) {
        console.error("Status poll failed:", err);
        clearInterval(interval);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  };


  // Poll all loaded scheduled tasks
  useEffect(() => {
    const scriptNames = [
      ...new Set(
        tasks
          .filter((task) => task && typeof task === "object")
          .map((task) => task.name)
          .filter(Boolean)
      ),
    ];

    if (scriptNames.length === 0) {
      return undefined;
    }

    const cleanups = scriptNames.map((scriptName) =>
      pollStatus(scriptName)
    );

    return () => {
      cleanups.forEach((cleanup) => cleanup());
    };
  }, [tasks]);

  // logs
  const [logs, setLogs] = useState([]);
  const [groups, setGroups] = useState({});
  const [activeTab, setActiveTab] = useState("logs");
  const tabs = ["logs", "status", "setting", "Logs_n"];

  const [openGroups, setOpenGroups] = useState({});
  console.log("groups_all", groups);
  const toggleGroup = (name) => {
    setOpenGroups((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };
  const infoLogs = logs.filter((log) => log.level === "info");
  const warningLogs = logs.filter((log) => log.level === "warning");
  const errorLogs = logs.filter((log) => log.level === "error");
  const criticalLogs = logs.filter((log) => log.level === "critical");

  const [showProcessModal, setShowModal] = useState(false);
  const [eventData, setEventData] = useState(null);
  useEffect(() => {
  const wsUrl =
    window.location.protocol === "https:"
      ? process.env.REACT_APP_WS_SECURE || "ws://192.168.1.103:8000/ws/logs"
      : process.env.REACT_APP_WS_UNSECURE || "ws://192.168.1.103:8000/ws/logs";

  const socket = new WebSocket(wsUrl);

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("datare", data);
        if (data.type === "event_type") {
          setEventData(data);
          setShowModal(true);
        }

        if (data.type === "log" || data.type === "event_type") {
          setGroups((prev) => {
            const existingLogs = prev[data.name]?.logs || [];

            const newLogs = Array.isArray(data.log) ? data.log : [data.log];

            return {
              ...prev,
              [data.name]: {
                count: data.count,
                logs: [...existingLogs, ...newLogs],
              },
            };
          });
        }
      } catch (err) {
        console.error("Failed to parse log:", err);
      }
    };

    return () => socket.close();
  }, []);

  const scripts = [
    { name: "Master_script", target: "master_function" },
    { name: "Normalization", target: "normalization_function" },
    {
      name: "Today_Odds",
      target: "Todays_odds_function",
    },
    {
      name: "Procesing",
      target: "processing_function",
      options: [
        { label: "H-2-H", value: "h_2_h_Que" },
        { label: "H-2-H-A", value: "h_2_h_Away_Que" },
        { label: "H-2-H-H", value: "h_2_h_Home_Que" },
        { label: "R_R", value: "ratio_result_scrapping" },
      ],
    },
    { name: "Getting_Scores", target: "scores_function" },
    { name: "Algorithim_Finder", target: "finder_function" },
  ];
  return (
    <>
      <div className="alg1_card">
        <div className="dashboard_header_wrapper">
          <h1 className="dashboard_control_title">CONTROL DASHBOARD</h1>
        </div>
        {/* dashboard_control ::  main  section  */}
        <div
          className={`dashboard_main ${
            activeTab === "status"
              ? "status_mode"
              : activeTab === "Logs_n"
              ? "log_mode"
              : ""
          }`}
        >
          {/* LEFT SIDE (75%) */}
          <div className="dashboard_left">
            <span className={`activeTab_badge ${activeTab ? "show" : ""}`}>
              {activeTab}
            </span>
            <div className="card logs_card">
              {activeTab === "logs" && (
                <div>
                  {Object.entries(groups)
                    .sort(([, groupA], [, groupB]) => {
                      const getPriority = (group) => {
                        const logsArray = group.logs
                          ? Array.isArray(group.logs)
                            ? group.logs
                            : [group.logs]
                          : [];

                        if (
                          logsArray.some(
                            (log) => log?.level?.toLowerCase() === "error"
                          )
                        )
                          return 3;
                        if (
                          logsArray.some(
                            (log) => log?.level?.toLowerCase() === "warning"
                          )
                        )
                          return 2;
                        if (
                          logsArray.some(
                            (log) => log?.level?.toLowerCase() === "info"
                          )
                        )
                          return 1;
                        return 0;
                      };

                      return getPriority(groupB) - getPriority(groupA);
                    })

                    .map(([name, group]) => {
                      const logsArray = group.logs
                        ? Array.isArray(group.logs)
                          ? group.logs
                          : [group.logs]
                        : [];

                      const hasError = logsArray.some(
                        (log) => log?.level?.toLowerCase() === "error"
                      );
                      const hasWarning = logsArray.some(
                        (log) => log?.level?.toLowerCase() === "warning"
                      );

                      let statusClass = "normal";
                      if (hasError) statusClass = "error";
                      else if (hasWarning) statusClass = "warning";

                      return (
                        <div key={name} style={{ marginBottom: "10px" }}>
                          {/* Header */}
                          <div
                            onClick={() => toggleGroup(name)}
                            className={`log-header ${statusClass}`}
                          >
                            {name} : (<span>{group.count}</span>)
                          </div>

                          {/* Expandable content */}
                          {openGroups[name] && (
                            <div style={{ paddingLeft: "15px" }}>
                              {(group.logs
                                ? Array.isArray(group.logs)
                                  ? group.logs
                                  : [group.logs]
                                : []
                              ).map((log, i) => (
                                <div
                                  key={i}
                                  className={`log-item ${
                                    hasError ? "error" : "normal"
                                  }`}
                                >
                                  <div className="log-main">
                                    [{log?.level}] {log?.message}
                                  </div>

                                  {hasError && (
                                    <div className="log-details">
                                      <div>
                                        <strong>Function:</strong>{" "}
                                        {log?.function}
                                      </div>
                                      <div>
                                        <strong>File:</strong> {log?.file}
                                      </div>
                                      <div>
                                        <strong>Error Type:</strong>{" "}
                                        {log?.error_type}
                                      </div>
                                      <div>
                                        <strong>Code:</strong> {log?.code}
                                      </div>
                                      <div>
                                        <strong>Line:</strong> {log?.line}
                                      </div>
                                      <div>
                                        <strong>Snap_Details:</strong>{" "}
                                        <ReactJson
                                          src={log.debug}
                                          collapsed={2}
                                          enableClipboard={true}
                                          displayDataTypes={false}
                                          name={false}
                                          theme="monokai"
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              )}
              {activeTab === "status" && StatusComponent}
              {activeTab === "setting" && <Setting_all />}
              {activeTab === "Logs_n" && <System_logs groups={groups} />}
            </div>

            {/* <div className="card nav_card">Logs</div> */}
            <div className="active_container">
              {tabs.map((tab) => (
                <div
                  key={tab}
                  className={`nav_card ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE (25%) */}
          <div className="dashboard_right">
            <div className="card small">
              <h3>HEALTH CHECK</h3>
              {Object.keys(stage).length === 0 ? (
                <div>No_Stage</div>
              ) : (
                Object.entries(stage).map(([scriptName, stageText]) => (
                  <div key={scriptName}>
                    Stage: {scriptName}: {stageText}
                  </div>
                ))
              )}
            </div>
            <div className="card small">
              <h3>RUN SCRIPTS </h3>
              <ul className="script_list">
                {scripts.map((script) => (
                  <li key={script.name} className="script_item">
                    {/* TOP ROW */}
                    <div className="script_row">
                      <span
                        className="clickable"
                        onClick={() => handleClick(script.name)}
                      >
                        {script.name.replace("_", " ")}
                      </span>

                      {script.options && (
                        <span
                          className="dropdown_icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDropdownClick(script.name);
                          }}
                        >
                          ▼
                        </span>
                      )}
                    </div>

                    {/* DROPDOWN OPTIONS (NEW) */}
                    {showDropdown === script.name && script.options && (
                      <div className="dropdown_menu">
                        {script.options.map((opt) => (
                          <div
                            key={opt.label}
                            className="dropdown_item"
                            onClick={() => {
                              handleRun(script.name, script.target, opt.value);
                              setShowDropdown(null);
                            }}
                          >
                            {opt.label}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* RUN + STATUS */}
                    {showRun === script.name && (
                      <div className="script_actions">
                        {status[script.name] !== "RUNNING" && (
                          <button
                            className="run_btn"
                            onClick={() =>
                              handleRun(script.name, script.target)
                            }
                            disabled={status[script.name] === "RUNNING"}
                            style={{
                              padding: "6px 12px",
                              cursor:
                                status[script.name] === "RUNNING"
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            Run
                          </button>
                        )}

                        <span
                          className={`status_main ${status[
                            script.name
                          ]?.toLowerCase()}`}
                          style={{ marginLeft: "10px" }}
                        >
                          {status[script.name]}
                        </span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* end :: dashboard control  */}
      </div>
      {showProcessModal && <Process_modal setShowModal={setShowModal} />}
    </>
  );
}
